/*
 * name: url协议格式化
 * more:
 * 1、如果url含http协议，则直接返回
 * 2、如果url没有http协议，则增加http协议和hostname
 */

define('util/host',[],function() {
  var protocolHost = window.location.protocol + '//' + window.location.host;
  return function(url) {
    if (/^http(s)?:\/\//gi.test(url)) {
      return url;
    }
    return protocolHost + url;
  };
});

